import { render, staticRenderFns } from "./DeleteMaterialGroup.vue?vue&type=template&id=66ed74b0&scoped=true&"
import script from "./DeleteMaterialGroup.vue?vue&type=script&lang=js&"
export * from "./DeleteMaterialGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66ed74b0",
  null
  
)

export default component.exports